import React from 'react';
import { Clock, History, Sparkles, Download } from 'lucide-react';
import api from '../api';

export default function Agent2History({ agent2History, agent2HistoryError, onRefresh }) {
  const exportToCSV = () => {
    if (!agent2History || agent2History.length === 0) return;

    // Headers em português para o relatório do usuário
    const headers = [
      "Data/Hora",
      "Gatilho",
      "Leads Iniciais",
      "Leads Finais",
      "Duplicados Removidos",
      "Sem Contato Removidos",
      "Telefones Normalizados",
      "Telefones Inválidos Removidos",
      "WhatsApps Normalizados",
      "WhatsApps Inválidos Removidos",
      "Emails Normalizados",
      "Emails Inválidos Removidos",
      "Classif: Email + WhatsApp",
      "Classif: Apenas WhatsApp",
      "Classif: Apenas Email",
      "Classif: Apenas Telefone",
      "Classif: Sem Contato"
    ];

    const rows = agent2History.map(entry => {
      const ts = new Date(entry.timestamp);
      const formattedDate = isNaN(ts) ? entry.timestamp : ts.toLocaleString('pt-BR');
      const triggerLabel = entry.trigger === 'auto_export' ? 'Auto / Exportação' : 'Manual';
      
      return [
        formattedDate,
        triggerLabel,
        entry.rows_before || 0,
        entry.rows_after || 0,
        entry.removed_duplicates || 0,
        entry.removed_without_contacts || 0,
        entry.ajustes?.telefones_normalizados || 0,
        entry.ajustes?.telefones_invalidos_removidos || 0,
        entry.ajustes?.whatsapps_normalizados || 0,
        entry.ajustes?.whatsapps_invalidos_removidos || 0,
        entry.ajustes?.emails_normalizados || 0,
        entry.ajustes?.emails_invalidos_removidos || 0,
        entry.classificacao?.['email+whatsapp'] || 0,
        entry.classificacao?.['whatsapp'] || 0,
        entry.classificacao?.['email'] || 0,
        entry.classificacao?.['telefone'] || 0,
        entry.classificacao?.['sem_contato'] || 0
      ];
    });

    const csvContent = [
      headers.join(";"),
      ...rows.map(e => e.join(";"))
    ].join("\n");

    const blob = new Blob(["\uFEFF" + csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", `relatorio_historico_agente2_${new Date().toISOString().slice(0,10)}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadReport = async (filename) => {
    try {
      const response = await api.get(`/exports/${filename}/download`, {
        responseType: 'blob'
      });
      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Erro ao baixar o relatório do Agente 2:", error);
    }
  };

  return (
    <div
      className="glass card"
      style={{ margin: '0 0 1.5rem 0', padding: '1.25rem', borderRadius: '18px', border: '1px solid rgba(116,242,255,0.1)' }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '1rem', flexWrap: 'wrap' }}>
        <Sparkles size={16} color="var(--accent)" />
        <h3 style={{ fontSize: '0.9rem', fontWeight: 700, color: 'var(--accent)', margin: 0 }}>
          Agente 02 · Histórico de Varreduras
        </h3>
        <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
          <button
            onClick={exportToCSV}
            disabled={!agent2History || agent2History.length === 0}
            className="glass"
            style={{ padding: '4px 12px', fontSize: '0.72rem', color: 'var(--text-secondary)', display: 'flex', alignItems: 'center', gap: '6px', opacity: (!agent2History || agent2History.length === 0) ? 0.5 : 1 }}
          >
            <Download size={12} /> Exportar Histórico
          </button>
          <button
            onClick={onRefresh}
            className="glass"
            style={{ padding: '4px 12px', fontSize: '0.72rem', color: 'var(--text-secondary)', display: 'flex', alignItems: 'center', gap: '6px' }}
          >
            <History size={12} /> Atualizar
          </button>
        </div>
      </div>

      {agent2HistoryError ? (
        <div
          style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px', padding: '1.25rem', background: 'rgba(231,76,60,0.06)', border: '1px solid rgba(231,76,60,0.18)', borderRadius: '12px' }}
        >
          <span style={{ fontSize: '0.82rem', color: '#e74c3c' }}>
            ⚠ Falha ao buscar histórico do Agente 2 — verifique se o servidor está rodando.
          </span>
          <button
            onClick={onRefresh}
            className="glass"
            style={{ padding: '5px 16px', fontSize: '0.75rem', color: 'var(--accent)', border: '1px solid rgba(116,242,255,0.2)', display: 'flex', alignItems: 'center', gap: '6px' }}
          >
            <History size={12} /> Tentar novamente
          </button>
        </div>
      ) : agent2History.length === 0 ? (
        <div style={{ color: 'var(--text-secondary)', fontSize: '0.82rem', padding: '0.5rem 0' }}>
          Nenhuma varredura registrada ainda. Execute "VALIDAR BASE" ou exporte o workbook para iniciar.
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', maxHeight: '320px', overflowY: 'auto' }}>
          {agent2History.map((entry, idx) => {
            const ts = new Date(entry.timestamp);
            const label = isNaN(ts) ? entry.timestamp : ts.toLocaleString('pt-BR');
            const triggerLabel = entry.trigger === 'auto_export' ? 'Auto · Exportação' : 'Manual';
            const triggerColor = entry.trigger === 'auto_export' ? 'var(--accent)' : 'var(--text-secondary)';
            return (
              <div
                key={idx}
                className="glass"
                style={{ display: 'grid', gridTemplateColumns: '1fr auto auto', gap: '0.75rem', padding: '0.65rem 0.9rem', borderRadius: '12px', background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.05)', fontSize: '0.8rem', alignItems: 'center' }}
              >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Clock size={11} color="var(--text-secondary)" />
                    <span style={{ color: 'var(--text-secondary)' }}>{label}</span>
                    <span style={{ fontSize: '0.7rem', padding: '1px 8px', borderRadius: '20px', background: 'rgba(116,242,255,0.07)', color: triggerColor, border: `1px solid ${triggerColor}33` }}>
                      {triggerLabel}
                    </span>
                  </div>
                  <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginTop: '2px' }}>
                    <span>📋 <strong>{entry.rows_before}</strong> → <strong>{entry.rows_after}</strong> linhas</span>
                    <span style={{ color: '#e74c3c' }}>🗑 {entry.removed_duplicates} dup.</span>
                    <span style={{ color: '#e67e22' }}>⚠ {entry.removed_without_contacts} sem contato</span>
                    {entry.ajustes?.telefones_normalizados > 0 && (
                      <span style={{ color: 'var(--accent)' }}>📞 {entry.ajustes.telefones_normalizados} tel. norm.</span>
                    )}
                    {entry.ajustes?.emails_normalizados > 0 && (
                      <span style={{ color: 'var(--accent)' }}>✉ {entry.ajustes.emails_normalizados} e-mail norm.</span>
                    )}
                  </div>
                </div>
                
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '3px', color: 'var(--text-secondary)', fontSize: '0.76rem' }}>
                  {entry.classificacao && (
                    <>
                      {entry.classificacao['email+whatsapp'] > 0 && <span>✉+📱 {entry.classificacao['email+whatsapp']}</span>}
                      {entry.classificacao['whatsapp'] > 0 && <span>📱 {entry.classificacao['whatsapp']}</span>}
                      {entry.classificacao['email'] > 0 && <span>✉ {entry.classificacao['email']}</span>}
                    </>
                  )}
                </div>

                {entry.report_csv ? (
                  <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '4px' }}>
                    <button
                      onClick={() => handleDownloadReport(entry.report_csv)}
                      className="glass"
                      title="Baixar relatório detalhado de leads limpos/ajustados"
                      style={{ padding: '6px 10px', fontSize: '0.72rem', color: 'var(--accent)', borderColor: 'rgba(116,242,255,0.2)', display: 'flex', alignItems: 'center', gap: '4px' }}
                    >
                      <Download size={11} /> Leads
                    </button>
                  </div>
                ) : (
                  <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '4px', opacity: 0.35, pointerEvents: 'none' }}>
                    <button
                      className="glass"
                      style={{ padding: '6px 10px', fontSize: '0.72rem', color: 'var(--text-secondary)', display: 'flex', alignItems: 'center', gap: '4px' }}
                    >
                      <Download size={11} /> N/A
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
